import { render, staticRenderFns } from "./ContainerListItem.vue?vue&type=template&id=187a3cda&scoped=true&"
import script from "./ContainerListItem.vue?vue&type=script&lang=js&"
export * from "./ContainerListItem.vue?vue&type=script&lang=js&"
import style0 from "./ContainerListItem.vue?vue&type=style&index=0&id=187a3cda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187a3cda",
  null
  
)

export default component.exports